import { render, staticRenderFns } from "./TraxUiForm.vue?vue&type=template&id=0cab852f"
import script from "./TraxUiForm.vue?vue&type=script&lang=js"
export * from "./TraxUiForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports